import { dataLockerVisualisationComponents } from '@/pages/dataLocker/visComponents';
import { EntityVisComponent } from '@/types/entity';
import { WidgetVisType } from '@/types/widget';
import { gameVisComponents, playerVisComponents, teamVisComponents } from './visualisationComponents';

export const entityVisualisationComponents: EntityVisComponent = {
  player: playerVisComponents,
  team: teamVisComponents,
  game: gameVisComponents,
  dataLocker: dataLockerVisualisationComponents,
};

export const NON_NAVIGABLE_WIDGETS: WidgetVisType[] = ['positionMap', 'info', 'minutesPlayed'];
export const COMING_SOON_WIDGETS: WidgetVisType[] = [];
export const HEADING_ONLY_NAVIGABLE_WIDGETS: WidgetVisType[] = ['squad'];
